<template>
    <div class="info">
        <b-container fluid>
            <b-row>
                <b-col class="mb-4" lg="12">
                    <h4>¿Qué vas a encontrar?</h4>
                </b-col>
                <b-col class="pt" lg="3">
                    <div class="col-color col1">
                        <img src="../assets/img/Fotoconcept.png" alt="">
                        <p class="bold">Concept Store con Productos Originales</p>
                        <p>Elección de productos únicos y cuidadosamente curados de marcas exclusivas que buscan ofrecerte lo mejor en diseño y calidad.</p>
                    </div>
                </b-col>
                <b-col class="pt" lg="3">
                    <div class="col-color col2">
                        <img src="../assets/img/Fototalleres.png" alt="">
                        <p class="bold">Talleres y Cursos de Temas de Actualidad</p>
                        <p>Actividades que abordan temas relevantes e innovadores, diseñados para aprender, compartir y crecer.</p>
                    </div>
                </b-col>
                <b-col class="pt" lg="3">
                    <div class="col-color col3">
                        <img src="../assets/img/Fotocomunidad.png" alt="">
                        <p class="bold">Una Comunidad Vibrante</p>
                        <p>Conectar con personas de diferentes intereses y edades, formando parte de una comunidad dinámica que valora la creatividad, el aprendizaje y la colaboración</p>
                    </div>
                </b-col>
                <b-col class="pt" lg="3">
                    <div class="col-color col4">
                        <img src="../assets/img/Fotoespacio.png" alt="">
                        <p class="bold">Un Espacio Seguro y Acogedor</p>
                        <p>Un ambiente donde te sentirás cómodo y bienvenido, un lugar pensado para que cada visita sea una experiencia memorable.</p>
                    </div>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
    export default {

    }
</script>

<style scoped>
.info{
    padding: 5% 0;
}
h4{
    font-size: 30px;
}
p{
    font-size: 18px;
    color: #fff;
}
.bold{
    margin-top: 20px;
    font-weight: 600;
}
.pt{
    padding-top: 7%;
}
.col-color{
    height: 100%;
    padding: 10%;
    position: relative;
}
.col-color img{
    margin-top: -50%;
    max-width: 100%;
}
.col1{
    background: #5D867C;
}
.col2{
    background: #BC8F50;
}
.col3{
    background: #D37353;
}
.col4{
    background: #EEBBAE;
}

@media (max-width: 992px){
    .pt{
        padding-top: 250px;
    }
}

@media (max-width: 600px){
    .pt{
        padding-top: 150px;
    }
}

</style>